// TIEEQEU HABER:
//   - clientConfig (la de los vmodels)
//   - flatConfig (la que necesita la pivtTable)
//   - serverConfig (la que neceista alvaro)
import { isNombre } from '@/utils/chart'
const cloneDeep = require('clone-deep')

/*
~~~~~~~~~~~~~~~~~~~~~ descripció general dels canvis de #bug-308-321 ~~~~~~~~~~~~~~~~~~~~~~
#bug-308-321

Nou sistema de "pasar notes a la taula"

Enlloc de tentir les notes per fora de les cel·les de la taula (en un array notes, apart) y llavors en el render de la taula (Table.vue ~380) intentar matchejar cada cel·la amb la seva "notes" (que es el que no funcionava be en alguns casos quan hi ha multiples nivells de headers)
Ara les cel·les son un "Object" amb {value,notes} amb les notes a dins, amb lo que NO cal matchejar res, ismplement si hi ha "cell.notes" el pinta.

El canvi nomes afecta a "taules", no a charts (dataUtils.js ~124), que continuen tenin el valors de la cel·la com a valor numeric (no Object)

Tots els canvis del commit estan annotats amb el titol: #bug-308-321

~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/

export function buildPivotTable(_raw, clientConfig, dimOptions, dimMetas, unit) {
  // Si la unit es nombre, los zeros se convierten a "undefined"!!!!
  let replaceZeroes = unit && isNombre(unit)
  // #bug-308-321:
  // El "cloneDeep" es carrega les "notes" amb lo que s'han de tornar a injectar...
  let raw = cloneDeep(_raw)
  _raw.values.forEach((v, i) => {
    if (v.notes) raw.values[i].notes = v.notes
    if (v.secret !== undefined) raw.values[i].secret = v.secret
  })
  clientConfig = cloneDeep(clientConfig)
  dimOptions = cloneDeep(dimOptions)
  dimMetas = cloneDeep(dimMetas)
  // let pivotConfig = expandConfig(clientConfig, nestConfig(clientConfig))
  // let nestedPivotConfig = clientConfig
  // let nestedPivotConfig = clientConfig
  let pivotConfig = clientConfigToTableConfig(clientConfig)

  pivotConfig.dimensions.sort((a, b) => a.index - b.index)

  let definition = pivotConfig.dimensions.reduce(
    (conf, dim) => {
      // conf[dim.role] ||= []
      conf[dim.role].push(dim.id)
      return conf
    },
    { rows: [], columns: [], filters: [], types: [], chart: [] }
  )

  let dimValues = pivotConfig.dimensions.reduce((dict, dim) => {
    let tmp = dim.values ? [...dim.values] : []
    tmp.sort((a, b) => a.index - b.index)
    dict[dim.id] = tmp.map(v => v.value)
    return dict
  }, {})

  ////////ORDER LOCATION FIXED/SORTED AS DATABASE /////////
  let locDim = Object.keys(dimMetas).find(el => dimMetas[el].type === 'location')

  let motherLoc = dimOptions[locDim][0]

  let getLocChildren = function (parent) {
    let arr = []
    if (parent) {
      parent.forEach(el => {
        arr.push(el.id)
        arr = arr.concat(getLocChildren(el.values))
      })
    }
    return arr
  }

  let orderedLoc = []
  orderedLoc.push(motherLoc.id)
  orderedLoc = orderedLoc.concat(getLocChildren(motherLoc.values))

  dimValues[locDim] = orderedLoc.filter(el => dimValues[locDim].includes(el))
  ////////////////////////////////////////////

  if (definition.rows.length === 0 && definition.columns.length === 0) {
    return null
  }
  if (definition.rows.length === 0) {
    // console.log('Could build table with 0 rows')
    // return null
    definition.rows = [definition.filters[0] || definition.columns[0]] //haicendo una tarmap "asi" no peta.. pero es dificil de "detectar"
    definition.FAKING_ROWS = true
  }

  if (definition.columns.length === 0) {
    definition.columns = definition.filters.slice(0, 1)
    definition.filters = definition.filters.slice(1)
  }
  if (definition.columns.length === 0) {
    // console.log('Could build table with 0 columns')
    // return null
    definition.columns = [definition.filters[0] || definition.rows[0]] //haicendo una tarmap "asi" no peta.. pero es dificil de "detectar"
    definition.FAKING_COLUMNS = true
  }

  // STEPS:
  // 1. learn positions on raw values of each relevant row and column dimension
  // 2. construct dictionary fron raw: {dimR1_i: dimR2_j: dimC1_k: dimC2_l: value}
  // 3. learn columns and rows on tableData from dimValues
  // 4. tableData from dictionary and columns and rows
  // STEP 1
  let filterDimensionPositions = definition.filters.map(d => {
    return raw.headers.findIndex(e => e === d)
  })

  let rowDimensionPositions = definition.rows.map(d => {
    return raw.headers.findIndex(e => e === d)
  })
  let columnDimensionPositions = definition.columns.map(d => {
    return raw.headers.findIndex(e => e === d)
  })
  let dimPositions = rowDimensionPositions.concat(columnDimensionPositions)
  let valuePosition = raw.headers.findIndex(e => e === 'value')
  let positions = dimPositions.concat(valuePosition)

  // STEP 1.5 FILTER
  let filteredValues = (raw.values || []).filter(row => {
    return definition.filters.every((dim, i) => {
      let idx = filterDimensionPositions[i]
      let tmp = dimValues[dim].indexOf(row[idx]) >= 0
      // if (tmp) {
      //   console.log('asdfasdfasd')
      // }
      return tmp
    })
  })
  // STEP 2
  let setNestedValue = (obj, keys, value) => {
    if (keys.length === 1) {
      obj[keys[0]] = value
    } else {
      if (!(keys[0] in obj)) obj[keys[0]] = {}
      return setNestedValue(obj[keys[0]], keys.slice(1), value)
    }
  }
  let reducer = (dict, row) => {
    let slicedRow = positions.map(i => row[i])
    let value = slicedRow[slicedRow.length - 1]
    // #bug-308-321:
    // Amb el nou sistema, les notes van dins la cel·la amb lo que cada cela pasa de ser cell = value a cell = {value:xx,notes:yyy}
    // Nomes s'aplica si el target es una "TAULA" (i.e. si hi ha targetChart, ho deixem com abans)
    if (clientConfig.targetChart) setNestedValue(dict, slicedRow.slice(0, -1), value)
    else setNestedValue(dict, slicedRow.slice(0, -1), { value, notes: row.notes, secret: row.secret })
    return dict
  }
  let dict = filteredValues.reduce(reducer, {})
  // console.log(dict)

  // STEP 3
  let getAllCombinations = function (fixed, candidates) {
    function rec(fixed, candidates) {
      if (!candidates[0]) return fixed
      return candidates[0].map(c => {
        return rec(fixed.concat(c), candidates.slice(1))
      })
    }
    return rec(fixed, candidates).flat(candidates.length - 1)
  }

  let rowDimensionValues = definition.rows.map(d => dimValues[d])
  let tableRows = getAllCombinations([], rowDimensionValues)

  let columnDimensionValues = definition.columns.map(d => dimValues[d])
  let tableColumns = getAllCombinations([], columnDimensionValues)

  // STEP 4 convert dict to tableData
  let getNestedValue = function (obj, keys) {
    if (keys.length === 1) {
      // MANTENEMOS LOS "0" ya veremos quien/como se ponen a null
      if (obj[keys[0]] === 0 && replaceZeroes) {
        console.log('replacing zero with undefined!')
        return undefined
      }
      return obj[keys[0]]
    } else {
      if (!obj[keys[0]]) {
        return undefined
      }
      return getNestedValue(obj[keys[0]], keys.slice(1))
    }
  }
  let prevRowLabels = []
  ///////////////////////////////
  // NESTING FOR LOCATIONS!!!
  ///////////////////////////////
  let sortedRowIds
  if (dimMetas[definition.rows[0]].type === 'location') {
    let locDim = definition.rows[0]
    let root = dimOptions[locDim][0]
    let allRowIds = tableRows.flat()
    let dive = node => {
      if (node.values) {
        let nestedChildren = node.values
          .filter(c => allRowIds.indexOf(c.id) >= 0)
          .map(child => dive(child))
        // no lo quieren, (y tampoco funcionaba con los "missing loc" de mas abajo...)
        // nestedChildren.sort((a, b) => {
        //   return allRowIds.indexOf(a.id) - allRowIds.indexOf(b.id)
        // })
        return { id: node.id, children: nestedChildren }
      } else {
        return { id: node.id }
      }
    }
    let tree = dive(root, {})
    let flatten = (node, arr) => {
      arr ||= []
      arr.push(node)
      if (node.children) {
        node.children.forEach(child => flatten(child, arr))
      }
      return arr.flat(Infinity)
    }
    let nestedTypeRows = flatten(tree) // rowDimensionValues

    dimOptions[locDim].forEach(d => {
      if (!nestedTypeRows.find(n => n.id === d.id)) {
        // console.log('pushing missing loc', d)
        nestedTypeRows.push(d)
      }
    })
    sortedRowIds = nestedTypeRows.map(d => d.id)
    // console.log('sortedRowIds', sortedRowIds)
  }
  ///////////////////////////////
  ///////////////////////////////

  let tableData = tableRows
    .map((r, rowIndex) => {
      let cols = tableColumns.map(c => {
        let aux = getNestedValue(dict, r.concat(c))
        return aux
      })
      // "emptyRows"
      // BORRAMOS LAS FILAS CON "todo nulls" (debe ser qeu no cumplian el "brandModel tree" u otra restriction)
      if (clientConfig.targetChart != 'pyramid-chart') {
        if (cols.every(d => d === null) || cols.every(d => d === undefined)) return null
      }

      let rows = r.map((key, i) => {
        // Quitamos ('') las labels repetidas en la row anterior
        let canHide = false
        let type = null
        let label, timeValue

        if (definition.rows[i] === 'valueId') {
          let val = pivotConfig.dimensions
            .find(d => d.id === 'valueId')
            .values.find(v => v.value === r[i])
          label = dimOptions[val.refKey]?.find(o => o.id === val.refId).label
          timeValue = dimOptions[val.refKey]?.find(o => o.id === val.refId).timeValue
        } else {
          label = dimOptions[definition.rows[i]].find(o => o.id === key).label
          timeValue = dimOptions[definition.rows[i]].find(o => o.id === key).timeValue
        }

        if (prevRowLabels[i] === label) {
          prevRowLabels[i] = label
          canHide = i === 0 && true //Solo aplica a la primera columna!
        } else prevRowLabels[i] = label

        //Guardamos el "type" pa luego settear el "indentIndex"
        if (dimMetas[definition.rows[i]].type === 'location') {
          type = dimOptions[definition.rows[i]].find(o => o.id === key).type
        } else {
          type = dimMetas[definition.rows[i]].label
        }
        if (sortedRowIds) rowIndex = sortedRowIds.indexOf(key)
        return {
          value: key,
          label: label,
          timeValue: timeValue,
          type: type,
          canHide: canHide,
          //AQUI HABRIA SI SE PUEDE "nestear" padres/hijos de distintos types
          // AQUI PETA EL xkhi5y9qkb porque rowIndex = -1 (no?)
          index: String(rowIndex).padStart(6, 0), //HAY que hacerlo con strings (Datatalbes lo ordena alphabetically)
        }
      })
      // let rows = r
      return rows.concat(cols)
    })
    .filter(r => r)

  //SETEAMOS indentIndex para los "rowIds"
  tableData.forEach(row => {
    definition.rows.forEach((dim, idx) => {
      let sortedTypes = dimMetas[dim].typeOptions.map(o => o.type) //.map(d => d.type)
      row[idx].indentIndex = sortedTypes.indexOf(row[idx].type)
    })
  })

  // Añadimos ` (type)` a las rows con id repetido
  let usedRowLabels = tableData.reduce((dict, row) => {
    row.forEach(cell => {
      if (cell && cell.label) {
        dict[cell.label] ||= {}
        dict[cell.label][cell.type] = true
      }
    })
    return dict
  }, {})

  tableData.forEach(row => {
    row.forEach(cell => {
      if (cell && cell.label && usedRowLabels[cell.label]) {
        if (Object.keys(usedRowLabels[cell.label]).length > 1) {
          let labelType = ''
          let type = dimMetas[locDim].typeOptions.find(el => el.type === cell.type)
          labelType = type?.label || cell.type
          cell.label = cell.label + ` (${labelType})`
        }
      }
    })
  })

  //Buscamos columnas con todo nulls
  let emptyCols = tableData.reduce((emptyCols, row) => {
    row.forEach((cell, i) => {
      if (cell !== null && cell !== undefined) emptyCols[i] = false
    })
    return emptyCols
  }, new Array(tableData[0] ? tableData[0].length : 0).fill(true))

  let headers = columnDimensionValues.map((headerRow, i) => {
    let mult = i > 0 ? columnDimensionValues[i - 1].length : 1
    return Array.from(Array(mult))
      .map(() => [...headerRow])
      .flat()
  })

  let tmpHeadersReversed = columnDimensionValues.reverse()
  headers = headers
    .reverse()
    .map((headerRow, i) => {
      let rowCols = definition.rows.map(rowHeader => {
        return {
          type: 'row',
          value: rowHeader,
          label: dimMetas[rowHeader].label, //i === 0 ? rowHeader + '_label' : '',
          groupClass: 'no-group',
        }
      })
      let currentGroup = 0
      let lastRefId = null
      let colCols = headerRow.map((colHeader, idx) => {
        let numberOfEmpties = 0
        let lengthHead = i > 0 ? tmpHeadersReversed[i - 1].length : 1
        let partialEmpty =
          i > 0 ? emptyCols.slice(lengthHead * idx + 2, lengthHead * idx + lengthHead + 2) : []
        partialEmpty.forEach(el => {
          if (el) numberOfEmpties += 1
        })
        let colSpan = i > 0 ? tmpHeadersReversed[i - 1].length - numberOfEmpties : 1
        let key = definition.columns[definition.columns.length - i - 1]
        let labelCandidate = dimOptions[key]?.find(o => o.id === colHeader)
        let val = pivotConfig.dimensions
          .find(d => d.id === key)
          .values.find(v => v.value === colHeader)
        if (key === 'valueId') {
          labelCandidate = dimOptions[val.refKey]?.find(o => o.id === val.refId)
        }

        if (key === 'valueId') {
          if (val.colGroup !== lastRefId) currentGroup++
          lastRefId = val.colGroup
        } else {
          currentGroup++
        }
        let label = labelCandidate ? labelCandidate.label : '?_' + colHeader
        // if (val.refLabel) label = val.refLabel
        // else if (val.deltaRefLabel) {
        //   let refLabelCandidate = dimOptions.metric.find(o => o.id === val.deltaRefLabel)
        //   label = `${refLabelCandidate.label} ` + label
        // }
        return {
          type: 'col',
          value: colHeader,
          label: label,
          colSpan: colSpan,
          colGroup: currentGroup,
          groupClass: [],
          chart: val?.chart,
          dimType: val?.type,
        }
      })
      colCols.forEach((col, i) => {
        if (!colCols[i - 1] || colCols[i - 1].colGroup !== col.colGroup)
          col.groupClass.push('group-first')
        if (!colCols[i + 1] || colCols[i + 1].colGroup !== col.colGroup)
          col.groupClass.push('group-last')
        col.groupClass = col.groupClass.join(' ')
      })
      return rowCols.concat(colCols)
    })
    .reverse()

  if (definition.FAKING_COLUMNS) {
    tableData = tableData.map(r => r.slice(0, rowDimensionValues.length))
    headers = [headers[0].slice(0, rowDimensionValues.length)]
    // tableData = tableData.map(r => r.slice(0, rowDimensionValues.length).concat(['']))
    // headers = [headers[0].slice(0, rowDimensionValues.length).concat([''])]
  }
  //DISABLED TO SEE FILTER INFORMATION
  // if (definition.FAKING_ROWS) {
  //   tableData = []
  // }

  //SETEAMOS emptyCol para que se pinten, pero en "gris" pff...
  if (headers.length) headers[headers.length - 1].forEach((h, i) => (h.isEmptyCol = emptyCols[i]))

  // Añadimos ` (type)` a las columnas con id repetido
  let usedColLabels = headers.reduce((dict, h) => {
    h.forEach(cell => {
      if (cell && cell.label) {
        dict[cell.label] ||= {}
        dict[cell.label][cell.dimType] = true
      }
    })
    return dict
  }, {})
  headers.forEach(h => {
    h.forEach(th => {
      if (th && th.label && usedColLabels[th.label]) {
        if (Object.keys(usedColLabels[th.label]).length > 1) {
          th.label = th.label + ` (${th.dimType})`
        }
      }
    })
  })
  return { header: headers, values: tableData, notes: raw.notes ? raw.notes : null }
}

export function getOptionAsValue(option) {
  let value = {
    value: option.id,
    // bold: option.highlightStyle || false,
    // chart: false,
    type: option.type,
    index: option.order,
    // subOptions: [],
  }

  return value
}
export function getDefaultsAsValues(options, defaultKey = 'defaultSingle') {
  // let filtered = options.filter(d => defaultKey === 'ALL' || d[defaultKey])
  let filtered = options.filter(d => d[defaultKey])
  if (filtered.length === 0) {
    // console.warn('No default found in', options)
    filtered = [...options]
  }
  if (defaultKey === 'defaultSingle') {
    filtered = [filtered[0]]
  }
  let values = filtered.map(f => {
    return getOptionAsValue(f)
  })
  values.forEach((d, i) => (d.index = i))
  return values
}

export function buildValueIds(config) {
  let valIdx = 0
  let metrics = config.dimensions
    .find(d => d.id === 'metric')
    .values.map(m => {
      valIdx = valIdx + 1
      return {
        id: m.value,
        valueId: valIdx,
        index: m.index,
        periodMod: m.periodMod,
        valueMod: m.valueMod,
      }
    })
  metrics.forEach(m => {
    if (m.id > 1000) {
      m.periodMod = 'year'
      m.valueMod = m.id - 1000
      // m.refLabel = 'Y-' + m.valueMod
      m.refLabel = new Date().getFullYear() - m.valueMod
      let tmp = [...metrics]
      tmp.sort((a, b) => a.index - b.index)
      m.id = tmp[0].id
    }
  })
  let deltas = config.dimensions
    .find(d => d.id === 'metric')
    .values.map((m, i) => {
      return (
        m.subOptions &&
        m.subOptions.map(d => {
          if (d.value === 'value') return

          valIdx = valIdx + 1
          return {
            valueId: valIdx,
            deltaRefLabel: m.subOptions.find(so => so.value === 'value') ? null : metrics[i].id,
            metricValueId1: 1,
            metricValueId2: metrics[i].valueId,
            type: d.value || d,
            index: d.value === 'abs' ? 0 : 1,
            chart: d.chart,
          }
        })
      )
    })
    .filter(d => d)
    .flat(1)
    .filter(d => d)

  metrics.forEach(m => {
    let metric = config.dimensions.find(d => d.id === 'metric').values.find(mm => mm.value === m.id)
    m.chart = metric.subOptions.find(so => so.value === 'value')?.chart
    m.hidden = metric.subOptions.findIndex(so => so.value === 'value') < 0
  })

  return {
    metrics,
    deltas,
  }
}
export function arrayToOb(dimensions) {
  let tmp = dimensions.reduce((ob, dim) => {
    ob[dim.id] = dim.values
    return ob
  }, {})
  return tmp
}
export function obToArray(dimensions) {
  let tmp = Object.keys(dimensions).map(key => {
    return {
      ...dimensions[key],
      id: key,
    }
  })
  return tmp
}
export function clientConfigToTableConfig(clientConfig) {
  let flatConfig = clientConfig

  // let { metrics, deltas } = buildValueIds(clientConfig)
  let res = JSON.parse(JSON.stringify(flatConfig))
  res.dimensions = res.dimensions.filter(d => d.id !== 'metric' && d.id !== 'delta')

  return res
}

// export function clientConfigToServerConfig(clientConfig, dimensionsOptions) {
export function clientConfigToServerConfig(clientConfig) {
  let res = JSON.parse(JSON.stringify(clientConfig))
  return res
}

import { extent as d3_extent } from 'd3-array'

export function getAllTimeTable(raw, clientConfig, dimOptions, dimMetas) {
  let noTimeConfig = JSON.parse(JSON.stringify(clientConfig))
  let timeDim = noTimeConfig.dimensions.find(d => {
    return dimMetas[d.id]?.type === 'time'
  })
  timeDim.role = 'columns'

  // Se cogian siempre los del primer "timeType" WRONG
  // timeDim.values = dimOptions[timeDim.id][0].values.map(val => {
  //   return {
  //     value: val.id,
  //   }
  // })
  // ahora se cogen los de "todos los / el" selected type"
  let timeTypeDim = noTimeConfig.dimensions.find(d => {
    return d.id === `${timeDim.id}_type`
  })
  let timeTypes = timeTypeDim.values.map(d => d.value)
  timeDim.values = dimOptions[timeDim.id]
    .filter(tv => timeTypes.indexOf(tv.type) >= 0)
    .map(val => {
      return {
        value: val.id,
      }
    })
  let data =
    raw && clientConfig && dimOptions
      ? buildPivotTable(raw, noTimeConfig, dimOptions, dimMetas)
      : null
  return data
}
export function getAllTimeValues(raw, clientConfig, dimOptions, dimMetas) {
  let data = getAllTimeTable(raw, clientConfig, dimOptions, dimMetas)
  let values = data.values.reduce(function (all, row) {
    return all.concat(row.slice(1).filter(v => !isNaN(v)))
  }, [])
  return values.filter(v => v)
}

export function getRangeForAllTimes(raw, clientConfig, dimOptions, dimMetas) {
  let values = getAllTimeValues(raw, clientConfig, dimOptions, dimMetas)
  let fullExtent = d3_extent(values)
  return fullExtent
}
